import { useApi } from '../services';

export const useListPersonProduct = () => useApi(`/query`, 'POST', {}, { id: "fitGetProductPerson", params: {} });

export const useGetProductByIdAsync = (idProduct) => useApi(`/v2/admin/${idProduct}/product`, 'GET', {}, {}, true);

export const useGetProducts = () => useApi(`/v2/product`, 'GET', {}, {}, true);

export const useGetProductByIds = () => useApi(`/v2/product/ids`, 'GET', {}, {}, true);

export const useProductExpire = (idProduct) => useApi(`v2/product/${idProduct}/expire`, 'DELETE', {}, {});

export const useProductRestore = (idProduct) => useApi(`v2/product/${idProduct}/restore`, 'PATCH', {}, {});
